
/**
 * Représente les convertisseurs
 */
export class Converters {
    /**
     * Convertir une date en string
     * @param date
     */
    public static convertirDateEnString(date: Date): string {
        function pad(s) { return (s < 10) ? '0' + s : s; }
        return [pad(date.getDate()), pad(date.getMonth() + 1), date.getFullYear()].join('/');
    }

    /**
     * Convertir un string en date
     * @param str
     */
    public static convertirStringEnDate(str: string): Date {
        var parts = str.split('/');
        return new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
    }
}
